export { default } from './WixStyleReactEnvironmentProvider.js';
